import { DefaultChatTransport } from "ai";
import { handleChatError } from "@/utils/chat-error-handler";

type UseChatConfigOptions = {
  getContextUrl: () => string | undefined;
  apiUrl: string;
  apiKey: string;
  onFinish?: () => void;
};

export const useChatConfig = ({
  getContextUrl,
  apiUrl,
  apiKey,
  onFinish,
}: UseChatConfigOptions) => {
  // Custom fetch that routes to the correct endpoint based on contextUrl
  const customFetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response> = async (_input, init) => {
    const contextUrl = getContextUrl();

    // Determine the correct endpoint
    const endpoint = contextUrl
      ? `${apiUrl}/v2/summarise-url`
      : `${apiUrl}/v2/completions`;

    const headers = new Headers(init?.headers ?? {});
    headers.set("Authorization", `Bearer ${apiKey}`);

    // Make the request to the correct endpoint
    const response = await fetch(endpoint, {
      ...init,
      headers,
    });

    return response;
  };

  return {
    transport: new DefaultChatTransport({
      api: `${apiUrl}/v2/completions`, // Default (will be overridden by custom fetch)
      fetch: customFetch,
      body: () => ({
        widgetOrigin: window.location.origin,
        pagePathname: window.location.pathname,
      }),
    }),
    experimental_throttle: 100,
    onFinish,
    onError: (error: Error) => {
      handleChatError(error, "useChat");
    },
  };
};
